import { combineReducers } from 'redux';

import { drawEntrySlice } from './draw-entry';

export const drawReducer = combineReducers({
  drawEntry: drawEntrySlice.reducer,
});
